import * as mqtt from 'mqtt/dist/mqtt.min';
import { Notify } from 'vant';
import router from '@/router';

const config = window.config || {};
console.log(config, 'config----------------');
const options = {
  clientId: 'testmqttws_' + (Math.random() * 1000000).toString(),
  username: config.mqttusername,
  password: config.mqttpassword,
  connectTimeout: 4000, // 超时时间
};
// console.log(options)
const server = config.mqtturl;
console.log(server, 'mqtt---server-------------');
const client = mqtt.connect(server, options); // you add a ws:// url here
// Create a client instance
export const connect = (userId) => {
  console.log(userId, 'connect============userId=====================');

  //建立连接
  client.on('connect', (e) => {
    console.log('mqtt连接成功', 'color: red;');
    //订阅主题 presence
    client.subscribe('user/' + userId, (err, res) => {
      //console.log("主题订阅成功")
      if (err) {
        //打印错误
        console.log('Subscribe to topics error', err);
        return;
      }
      console.log('Subscribe to topics res', res);
    });
  });
  client.on('reconnect', (error) => {
    console.log('正在重连:', error);
  });
  //如果连接错误，打印错误
  client.on('error', (err) => {
    console.log('mqtt.connect error', err);
    client.end();
  });
  //如果client订阅主题成功，那么这里就是当接收到自己订阅主题的处理逻辑
  client.on('message', (topic, message) => {
    console.log('mqtt', message);
    // message is Buffer,此处就是打印消息的具体内容
    let msg = JSON.parse(message.toString());
    if (msg.msgtype != 4) {
      console.log('mqtt');
      //console.log("msg==", msg)
      Notify({
        type: 'primary',
        duration: 4000,
        message: msg.msg,
        onClick: () => {
          const { orderid } = msg;
          console.log('我点击了');
          router.push({
            path: '/order',
            query: {
              id: orderid,
            },
          });
        },
      });
      console.log('message==', msg);
      // store.dispatch('SET_MESSAGE', msg)
      // store.dispatch('GetMessageCount')
    }
  });
};
export const unconnect = () => {
  console.log('服务器已断开连接！');
  client.end();
};
